import { gql } from "@apollo/client";

export const GET_PROMOTIONAL_BANNER = gql`
  query getPromotionalBanner($branchName: String!, $preview: Boolean!) {
    getPromotionalBanner(branchName: $branchName, preview: $preview) {
      variant
      backgroundColour {
        tokenName
      }
      fontColour {
        tokenName
      }
      isSticky
      contentMessages {
        type
        message
      }
      pagesToExclude
    }
  }
`;
